import React from "react";

export default function VersionPopup(){
    return(
        <div className="text-center">
            <p className="text-xl font-bold">Credits</p>
            <ul className="text-center mb-5">
                <li>Iakovos Petrou</li>
                <li>Kevin Nunes da Silva</li>
                <li>Marten Tacoma</li>
                <li>Jan Derksen</li>
                <li>Eric Epping</li>
                <li>Wim Pool</li>
            </ul>
            <p className="text-xl font-bold">Special Thanks</p>
            <ul className="text-center mb-5">
                <li>Erica Koning</li>
                <li>Zeynep Erdem</li>
                <li>Doran Pauka</li>
                <li>The crew of the RV Pelagia</li>
            </ul>
        <p className="text-xl font-bold">{"Version "+process.env.REACT_APP_VERSION}</p>

        </div>
    )
}